export { SelfviewComponent } from './selfview.component';
